module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-mostpopular-1-cf19729c8bb37b6d6dc87cf7a3354f89.webp";